import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormGroup, Validators, ReactiveFormsModule, FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import {
  confirmedValidator,
  fourDigitsValidator,
  noLeadingSpaces,
} from '../../../../../../assets/utility/form.validators';
import { selectResetUserPinIsLoading } from '../../../../../ngrx/auth/auth.selectors';
import { Store } from '@ngrx/store';
import { FormUtilityService } from 'src/app/modules/core/services/form-utility.service';
import { toggleHeadlessStepperStep } from '../../../../../ngrx/misc/misc.actions';
import { AsyncPipe } from '@angular/common';
import { BeyAuthAsideBrandingComponent } from '../../../components/bey-auth-aside-branding/bey-auth-aside-branding.component';
import { BeyButtonComponent } from '../../../../shared/components/bey-button/bey-button.component';
import { BeyInputPinComponent } from '../../../../shared/components/bey-input-pin/bey-input-pin.component';
import { BeyAuthHeaderBrandingComponent } from '../../../components/bey-auth-header-branding/bey-auth-header-branding.component';
import { GetElementIdDirective } from '../../../../shared/directives/get-element-id.directive';

export interface ResetFormBody {
  pin: FormControl<string>;
  confirm_pin: FormControl<string>;
}
@Component({
  selector: 'bey-new-pin',
  templateUrl: './new-pin.component.html',
  styleUrls: ['./new-pin.component.scss'],
  standalone: true,
  imports: [
    BeyAuthHeaderBrandingComponent,
    ReactiveFormsModule,
    BeyInputPinComponent,
    BeyButtonComponent,
    BeyAuthAsideBrandingComponent,
    AsyncPipe,
    GetElementIdDirective,
  ],
})
export class NewPinComponent implements OnInit {
  resetUserPinIsLoading$: Observable<boolean>;
  newPinForm: FormGroup<ResetFormBody>;

  @Output()
  onNext: EventEmitter<{ formGroup: FormGroup<ResetFormBody>; step: number }> = new EventEmitter<{
    formGroup: UntypedFormGroup;
    step: number;
  }>();

  constructor(public router: Router, private store$: Store, public formUtility: FormUtilityService) {}

  ngOnInit(): void {
    this.resetUserPinIsLoading$ = this.store$.select(selectResetUserPinIsLoading);

    this.newPinForm = new FormBuilder().group(
      {
        pin: new FormControl('', [
          Validators.required,
          noLeadingSpaces,
          fourDigitsValidator,
          Validators.pattern(/^[0-9]*$/),
        ]),
        confirm_pin: new FormControl('', [
          Validators.required,
          noLeadingSpaces,
          fourDigitsValidator,
          Validators.pattern(/^[0-9]*$/),
        ]),
      },
      { validators: confirmedValidator('pin', 'confirm_pin') }
    );
  }

  handleSubmit(): void {
    if (this.newPinForm.valid) {
      this.onNext.emit({
        step: 2,
        formGroup: this.newPinForm,
      });
    }
  }

  onBackClick() {
    this.store$.dispatch(toggleHeadlessStepperStep({ currentStep: 0 }));
  }
}
